"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const slides = [{
  id: 1,
  title: "MONTEVIDEO\URUGUAY",
  subtitle: "De Uruguay para el mundo!\xA0 Piénsalo, deséalo y contáctanos. Nosotros nos encargamos. Tu viaje, nuestra pasión!\xA0",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1671966/img/montevideo_skyline_travel.png",
  align: "left",
  ctaText: "EXPLORA NUESTRAS PROMOS\n",
  ctaLink: "/GlobalStagesPage",
  titleClassName: "relative h-full w-full max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex flex-col justify-center items-start text-left bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1671966/img/palacio_salvo_montevideo.png)] bg-cover bg-center"
}, {
  id: 2,
  title: "MADRID\nSPAIN",
  subtitle: "From Gaudí's masterpieces to the Mediterranean breeze, discover Europe's most vibrant cultural hub.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1671966/img/barcelona_architecture_travel.png",
  align: "right",
  ctaText: "View Roster",
  ctaLink: "/RosterPage"
}, {
  id: 3,
  title: "RIO DE JANEIRO/BRASIL",
  subtitle: "A neon-lit symphony of tradition and futurism where every corner tells a unique story.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1671966/img/tokyo_shibuya_travel.png",
  align: "left",
  ctaText: "Contáctanos",
  ctaLink: "#promoinquiryform"
}];
export default function TravelDestinationsCarousel() {
  return;
}